import axios from '../../http_v2'
export default {
  number:(params)=> {
    return axios.post('opservice/marketingCampaign/push/number',params)
  },
  list: (id, params) => {
    // 获取参会人列表
    // return axios.post('activityservice/prticipantsearch/show/' + id, params)
    return axios.post('activityservice/prticipantsearch/show/phone/' + id, params)
  },
  template: (params) => {
    return axios.post('activityservice/prticipantsearch/download', params)
  },
  import: (params) => {
    return axios.post('activityservice/prticipantsearch/import', params)
  },
  export: (params) => {
    return axios.post('activityservice/prticipantExcl/export', params)
  },
  audit: (id, params) => {
    // 获取参会人列表
    return axios.post('activityservice/contact/audit/' + id, params)
  },
  updateAll: (params) => {
    return axios.post('activityservice/prticipant/batchupdate', params)
  },
  add: (params) => {
    return axios.post('activityservice/prticipant/transfer', params)
  },
  del: (params) => {
    return axios.post('activityservice/prticipant/delete', params)
  },
  delAll: (params) => {
    return axios.post('activityservice/prticipant/batchdelete', params)
  },
  field: (params) => {
    return axios.get('activityservice/prticipantsearch/field', params)
  },
  report: (params) => {
    return axios.get('activityservice/contact/getinfo2/' + params)
  },
  // 分享数据
  shareReport: (params) => {
    return axios.post('marketcenter/share/sharecode/list', params)
  },
  // 分享数据详情POST
  shareReportDetail: (params) => {
    return axios.post('marketcenter/share/code/detail/list', params)
  },
  // 获取导入日志
  getImportLog: (params) => {
    return axios.post('activityservice/prticipantsearch/importLog', params)
  },
  // 获取导入日志详情
  getImportLogDetail: (params) => {
    return axios.post('activityservice/prticipantsearch/importLog/detail', params)
  },
  // 获取导入日志Count
  getImportLogDetailCount: (params) => {
    return axios.get('activityservice/prticipantsearch/importLog/detail/count', params)
  },
  uploadExcel: 'activityservice/prticipantExcl/put', //上传excel

  sendMessageUrl: 'activityservice/sms/send', //发送短信
  getInsertFieldList: 'activityservice/smstemplate/field', //获取插入字段
  trunclue: (params) => {
    return axios.post('activityservice/prticipant/toapplyformsubmit?id=' + params)
  },
  // 批量转线索
  clueBatch: (params) => {
    return axios.post('activityservice/prticipant/toapplyformsubmit/batch', params)
  },
  // 发送邮件
  sendEmail:(id, params) => {
    return axios.post('activityservice/prticipantsearch/sendmail/'+ id, params)
  }
}
